import { jsx as _jsx } from "react/jsx-runtime";
import { useState } from "react";
import { useResource } from "@rest-hooks/core";
import { SalespersonResource, LoginResource } from "@ploy-lib/rest-resources";
import { DployAutocomplete } from "@ploy-ui/form-fields";
import { apiResourceUrl } from "@ploy-lib/core";
export const SalespersonSelector = (props) => {
    const { salespersonId, applicationId } = props;
    const { vendor: currentVendor } = useResource(LoginResource.status(), {});
    const salespeople = (useResource(SalespersonResource.list(), {
        vendorId: currentVendor?.id
    }) || []);
    const [selected, setSelected] = useState(salespeople.find(x => x.salespersonId === salespersonId));
    const handleSalespersonChange = (e, value) => {
        setSelected(value ?? undefined);
        if (!value)
            return;
        fetch(apiResourceUrl(`applications/${applicationId}/salespersonId`), {
            method: "POST",
            body: new Blob([
                JSON.stringify({
                    salespersonId: value.salespersonId
                })
            ], {
                type: "application/json"
            }),
            headers: {
                accept: "application/json"
            }
        });
    };
    return (_jsx(DployAutocomplete, { style: { width: 300 }, value: selected, items: salespeople, onChange: handleSalespersonChange, fullWidth: true, getItemLabel: item => item.fullName || `${item.firstname} ${item.lastname}`, disableClearable: true }));
};
//# sourceMappingURL=SalespersonSelector.js.map